export default __webpack_public_path__ + "1f578277ff20d01348fa95bc2ebeb955.png";